import React from "react";
import { Selector } from "../../../services/visualLibraryService";

export const Languages = ({ languagesList, onItemSelected }) => {
  return (
    <Selector
      items={languagesList}
      onItemSelected={onItemSelected}
      selectedIndex={languagesList.findIndex(item => item.active)}
    />
  );
};
